module.exports = __webpack_public_path__ + "img/3.65e837f5.jpg";